/* eslint-disable unicorn/consistent-function-scoping */
import { Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DataState, EXTERNAL_LINKS, routes } from '@libs/utils';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { ContractStatus } from '@ffd/api-client';
import { SiteSetupComponentService, StepNumberEnum } from './site-setup.component.service';
const HUBSPOT_CTA_TIMEOUT_MS = 3000;
@Component({
  selector: 'lib-site-setup',
  imports: [CommonModule, RouterModule, TranslateModule, LottieComponent],
  templateUrl: './site-setup.component.html',
  styleUrl: './site-setup.component.scss',
  providers: [SiteSetupComponentService],
})
export class SiteSetupComponent implements OnInit {
  private readonly siteSetupComponentService = inject(SiteSetupComponentService);

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };
  public DataState = DataState;
  public vmSignal = this.siteSetupComponentService.viewModel;

  public isNewModalDesign = computed(() =>
    [
      StepNumberEnum.SoftwareLicenseAgreement,
      StepNumberEnum.ServerInstallationChecklist,
      StepNumberEnum.ServerInstallationDownload,
    ].includes(this.vmSignal().currentStepFromUser),
  );

  public modalClass = computed(() => {
    switch (this.vmSignal().currentStepFromUser) {
      case StepNumberEnum.ServerInstallationChecklist: {
        return 'w-[505px]';
      }

      case StepNumberEnum.ServerInstallationDownload: {
        return 'w-[456px]';
      }

      default: {
        return this.vmSignal().contract?.data?.contractStatus === ContractStatus.SIGNED ? 'w-[505px]' : 'h-[80%] w-[640px]';
      }
    }
  });

  public StepNumberEnum = StepNumberEnum;
  public routes = routes;

  public ngOnInit(): void {
    this.siteSetupComponentService.init();
    this.showHubspotCta();
  }

  protected onLogoClick(): void {
    window.open(EXTERNAL_LINKS.FFD_WEBSITE, '_blank');
  }

  private showHubspotCta(): void {
    setTimeout(() => {
      // Add global CSS rule for all HubSpot CTA elements
      const styleId = 'hubspot-cta-transform-fix';
      if (!document.querySelector(`#${styleId}`)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          body #hs-web-interactives-bottom-anchor [id^='hs-overlay-cta-'] {
            /* stylelint-disable-next-line declaration-no-important */
            transform: translateX(0px) !important;
          }
        `;
        document.head.append(style);
      }
    }, HUBSPOT_CTA_TIMEOUT_MS);
  }
}
